module.exports = __webpack_public_path__ + "static/media/waffle-queen.2b580639.png";